var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTimeOut(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icTimeOut") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.7735423,0.32 C21.1917085,0.32 27.2270846,6.35537606 27.2270846,13.7735423 C27.2270846,21.1917085 21.1917085,27.2270846 13.7735423,27.2270846 C6.35537606,27.2270846 0.32,21.1917085 0.32,13.7735423 C0.32,6.35537606 6.35537606,0.32 13.7735423,0.32 Z M13.7735423,1.5335423 C7.02405659,1.5335423 1.5335423,7.02405659 1.5335423,13.7735423 C1.5335423,20.523028 7.02405659,26.0135423 13.7735423,26.0135423 C20.523028,26.0135423 26.0135423,20.523028 26.0135423,13.7735423 C26.0135423,7.02405659 20.523028,1.5335423 13.7735423,1.5335423 Z M13.8409918,6.08 C14.1506593,6.08 14.4019837,6.34625199 14.4019837,6.67167109 L14.4019837,14.7101145 L17.9317444,10.98732 C18.1494092,10.7577516 18.5062001,10.7577516 18.7249869,10.98732 C18.9426517,11.2180717 18.9426517,11.5943746 18.7249869,11.8239429 L14.2370521,16.5573117 C14.1304636,16.6697292 13.9868497,16.7300796 13.8409918,16.7300796 C13.7691849,16.7300796 13.696256,16.7135128 13.626693,16.6851126 C13.416882,16.5939953 13.28,16.3774436 13.28,16.1384085 L13.28,6.67167109 C13.28,6.34625199 13.5313243,6.08 13.8409918,6.08 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icTimeOut",
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimeOut);
export default __webpack_public_path__ + "static/media/icTimeOut.60160636a8dc3d2950b007ef4ace8047.svg";
export { ForwardRef as ReactComponent };